import type { FeedbackReason, FeedbackTrigger } from '../names';
import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useUserRedirected = () =>
	useSendEvent(events.common.userRedirected);

export const useShowFeedbackModal = ({ reason }: { reason: FeedbackReason }) =>
	useSendEvent<{
		modal_view_trigger?: FeedbackTrigger;
	}>(
		events.common.feedbackModalShown,
		{ modal_view_reason: reason },
		{ forceSendDemoUser: true }
	);
